import clsx from 'clsx';

export function Logo({ size = 24, className }: { size?: number; className?: string }) {
  return (
    <svg viewBox="0 0 64 64" width={size} height={size} fill="none" className={clsx('shrink-0', className)} aria-label="Ardacious Inner Circle">
      <circle cx="32" cy="32" r="28" stroke="currentColor" strokeWidth="2"/>
      <circle cx="32" cy="32" r="18" stroke="currentColor" strokeWidth="2.5"/>
      <circle cx="32" cy="32" r="6" fill="currentColor"/>
    </svg>
  );
}

export function Wordmark({ className }: { className?: string }) {
  return (
    <div className={clsx('inline-flex items-center gap-2 text-ink', className)}>
      <Logo size={28} />
      <div className="leading-none">
        <div className="text-[10px] tracking-[0.18em] uppercase text-muted font-medium">Ardacious</div>
        <div className="text-[18px] font-bold tracking-tight">inner circle</div>
      </div>
    </div>
  );
}
